// extracted by mini-css-extract-plugin
module.exports = {"information":"df5dab2e92--information--1tofM","questions":"df5dab2e92--questions--1jgUa"};